import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";

const NavBar: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <section className="DataTable__navBar px-6">{children}</section>
);

export default observer(NavBar);
